module.exports = __webpack_public_path__ + "img/chart-scatter-bubble.19a4cf8c.svg";